import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center font-bold" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "w-5 float-left font-normal text-subtle text-sm pt-1 pr-2 opacity-0" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 加入团队 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 请打开谈信手机app，加入团队。也可扫描下方二维码下载，体验安全感团队。 ")

import { useDialogPluginComponent } from 'quasar'

export default /*#__PURE__*/_defineComponent({
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {


const { dialogRef, onDialogHide, onDialogCancel } = useDialogPluginComponent()

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    onHide: _unref(onDialogHide),
    class: "q-dialog__backdrop_dark"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "flex flex-col justify-center h-20 px-4" }, {
            default: _withCtx(() => [
              _createElementVNode("h3", _hoisted_1, [
                _hoisted_2,
                _hoisted_3,
                _createElementVNode("i", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onDialogCancel) && _unref(onDialogCancel)(...args))),
                  class: "iconfont float-right font-normal text-subtle text-sm pt-1 pr-2 cursor-pointer"
                }, "  ")
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "px-8" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "text-center my-8" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_img, {
                src: require('theme/icons/qrcode.png'),
                width: "113px"
              }, null, 8, ["src"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}
}

})